import { ukZipcodeRegex, caZipCodeRegex } from 'common/validators';

class BaseZipcodeFormatter {
  static formatZipcode(zipcode) {
    if (!zipcode) {
      return '';
    }

    return zipcode.trim().toUpperCase();
  }
}

class UKZipcodeFormatter extends BaseZipcodeFormatter {
  static formatZipcode(zipcode) {
    zipcode = super.formatZipcode(zipcode);
    zipcode = zipcode.replace(/\s/g, '');

    const regex_result = zipcode.match(ukZipcodeRegex);

    if (regex_result) {
      const first_part = regex_result[3];
      if (first_part && first_part.length > 0) {
        const second_part = zipcode.slice(first_part.length);
        const final_val = `${first_part} ${second_part}`;
        return final_val.toUpperCase();
      }
    }

    return zipcode;
  }
}

class CAZipcodeFormatter extends BaseZipcodeFormatter {
  static formatZipcode(zipcode) {
    zipcode = super.formatZipcode(zipcode);
    zipcode = zipcode.replace(/\s/g, '');

    if (zipcode.length == 6) {
      const regex_result = zipcode.match(caZipCodeRegex);
      if (regex_result) {
        return `${zipcode.substring(0, 3)} ${zipcode.substring(3)}`;
      }
    }

    return zipcode;
  }
}

export const formatZipcode = function(zipcode, country_iso) {
  switch (country_iso) {
    case 'GB':
      return UKZipcodeFormatter.formatZipcode(zipcode);
    case 'CA':
      return CAZipcodeFormatter.formatZipcode(zipcode);
    default:
      return BaseZipcodeFormatter.formatZipcode(zipcode);
  }
};
